/**
 * Entry point that only contains the base.js
 * Meant for react pages that need some features for their surrounding
 * page elements (search, side nav, language switch, mini cart, etc.)
 */
import baseInitialize from './base';

baseInitialize();
